// removed by extract-text-webpack-plugin
module.exports = {"image":"_1w4262KQSaH570kQItuABU"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Image/Image.module.scss
// module id = 777
// module chunks = 0